// Bilingual content for Démarches (checklist) and Astuces (tips).
// Proper nouns, acronyms, amounts, durations and URLs are kept identical across languages.

export const DEMARCHES = [
  {
    theme: { fr: "Titre de séjour", en: "Residence permit" },
    icon: "IdCard",
    items: [
      {
        id: "vls-valider",
        title: { fr: "Valider mon VLS-TS", en: "Validate my VLS-TS" },
        why: {
          fr: "À faire dans les 3 mois suivant l'arrivée, sinon le visa devient invalide ; l'attestation est téléchargeable immédiatement.",
          en: "Do this within 3 months of arrival, otherwise the visa becomes invalid; the certificate is downloadable immediately.",
        },
        link: "https://administration-etrangers-en-france.interieur.gouv.fr",
        linkLabel: "ANEF",
      },
      {
        id: "vls-renouveler",
        title: { fr: "Anticiper le renouvellement", en: "Plan ahead for renewal" },
        why: {
          fr: "La demande se fait sur l'ANEF, 2 à 4 mois avant l'expiration du titre.",
          en: "The request is made on ANEF, 2 to 4 months before the permit expires.",
        },
        link: "https://administration-etrangers-en-france.interieur.gouv.fr",
        linkLabel: "ANEF",
      },
    ],
  },
  {
    theme: { fr: "Santé", en: "Health" },
    icon: "HeartPulse",
    items: [
      {
        id: "secu",
        title: { fr: "M'inscrire à la Sécurité sociale", en: "Register with Sécurité sociale" },
        why: {
          fr: "Gratuit et obligatoire au-delà de 3 mois, à faire APRÈS avoir validé le VLS-TS ; on reçoit un numéro provisoire puis la carte Vitale (comptez 2 à 6 mois).",
          en: "Free and mandatory beyond 3 months, to be done AFTER validating the VLS-TS; you receive a temporary number then the carte Vitale (allow 2 to 6 months).",
        },
        link: "https://etudiant-etranger.ameli.fr",
        linkLabel: "Ameli",
      },
      {
        id: "medecin-traitant",
        title: { fr: "Déclarer un médecin traitant", en: "Declare a family doctor" },
        why: {
          fr: "Nécessaire pour être bien remboursé ; trouver un médecin proche.",
          en: "Needed to be properly reimbursed; find a doctor nearby.",
        },
        link: "https://annuairesante.ameli.fr",
        linkLabel: "annuairesante.ameli.fr",
      },
      {
        id: "complementaire",
        title: { fr: "Souscrire une complémentaire santé", en: "Get complementary health insurance" },
        why: {
          fr: "La Sécu ne rembourse pas tout ; prendre une mutuelle, ou demander la Complémentaire santé solidaire (CSS) si les revenus sont faibles (parfois gratuite).",
          en: "Sécu does not reimburse everything; get a mutuelle, or apply for the Complémentaire santé solidaire (CSS) if income is low (sometimes free).",
        },
        link: "https://www.ameli.fr",
        linkLabel: "Ameli",
      },
    ],
  },
  {
    theme: { fr: "Études & CROUS", en: "Studies & CROUS" },
    icon: "GraduationCap",
    items: [
      {
        id: "cvec",
        title: { fr: "Payer la CVEC (105 €)", en: "Pay the CVEC (105 €)" },
        why: {
          fr: "Obligatoire AVANT l'inscription dans l'établissement ; les boursiers du gouvernement français en sont exonérés mais doivent fournir l'attestation.",
          en: "Mandatory BEFORE enrolling in your institution; French government scholarship holders are exempt but must provide the certificate.",
        },
        link: "https://cvec.etudiant.gouv.fr",
        linkLabel: "cvec.etudiant.gouv.fr",
      },
      {
        id: "crous-logement",
        title: { fr: "Explorer le logement CROUS & Resto U", en: "Explore CROUS housing & Resto U" },
        why: {
          fr: "Loyers modérés et repas complets à environ 3,30 € (1 € pour les boursiers).",
          en: "Moderate rents and full meals at around 3,30 € (1 € for scholarship holders).",
        },
        link: "https://www.messervices.etudiant.gouv.fr",
        linkLabel: "messervices.etudiant.gouv.fr",
      },
    ],
  },
  {
    theme: { fr: "Logement & aides", en: "Housing & benefits" },
    icon: "Home",
    items: [
      {
        id: "compte-bancaire",
        title: { fr: "Ouvrir un compte bancaire", en: "Open a bank account" },
        why: {
          fr: "Un RIB français est demandé pour l'APL, les remboursements de la Sécu et le salaire.",
          en: "A French RIB is required for the APL, Sécu reimbursements and your salary.",
        },
        link: null,
      },
      {
        id: "apl",
        title: { fr: "Demander l'APL", en: "Apply for the APL" },
        why: {
          fr: "Aide au logement versée par la CAF ; beaucoup d'étudiants y ont droit — faire la simulation.",
          en: "Housing benefit paid by the CAF; many students are eligible — run the simulation.",
        },
        link: "https://www.caf.fr",
        linkLabel: "CAF",
      },
      {
        id: "assurance-habitation",
        title: { fr: "Souscrire une assurance habitation", en: "Take out home insurance" },
        why: {
          fr: "Obligatoire pour signer un bail ; souvent quelques euros par mois.",
          en: "Mandatory to sign a lease; often a few euros per month.",
        },
        link: null,
      },
    ],
  },
  {
    theme: { fr: "Travailler", en: "Working" },
    icon: "Briefcase",
    items: [
      {
        id: "droit-travail",
        title: { fr: "Comprendre mon droit au travail", en: "Understand my right to work" },
        why: {
          fr: "Avec un titre étudiant, on peut travailler jusqu'à 964 h/an (60 % d'un temps plein), calculées sur 12 mois à partir de la date du titre ; l'employeur déclare l'embauche à la préfecture au moins 2 jours avant ; les stages conventionnés ne comptent pas. Étudiants algériens : 803,5 h + autorisation de travail.",
          en: "With a student permit, you may work up to 964 h/year (60 % of full time), calculated over 12 months from the permit date; the employer declares the hire to the préfecture at least 2 days beforehand; conventioned internships do not count. Algerian students: 803,5 h + work authorization.",
        },
        link: "https://www.service-public.gouv.fr/particuliers/vosdroits/F2713",
        linkLabel: "Service-Public",
      },
    ],
  },
];

export const ASTUCES = [
  {
    title: { fr: "Culture & codes du quotidien", en: "Culture & everyday etiquette" },
    icon: "Sparkles",
    tips: {
      fr: [
        "On se dit « bonjour » en entrant dans un commerce et « au revoir » en partant — ça compte beaucoup ici.",
        "Vouvoyez par défaut les inconnus, les profs et l'administration ; on passe au « tu » quand on vous le propose.",
        "Administrations et beaucoup de commerces ferment tôt (souvent 17h-18h) et le dimanche ; anticipez vos démarches en semaine.",
        "Le repas est un moment social : un déjeuner entre amis peut durer deux heures.",
      ],
      en: [
        "Say « bonjour » when entering a shop and « au revoir » when leaving — it matters a lot here.",
        "Use « vous » by default with strangers, teachers and administration; switch to « tu » when invited to.",
        "Government offices and many shops close early (often 17h-18h) and on Sundays; plan your errands on weekdays.",
        "A meal is a social moment: lunch with friends can last two hours.",
      ],
    },
  },
  {
    title: { fr: "Argent & bons plans", en: "Money & good deals" },
    icon: "PiggyBank",
    tips: {
      fr: [
        "Gardez toujours votre carte étudiante : réductions ciné, musées, transports, spectacles.",
        "Musées nationaux gratuits pour les -26 ans résidents de l'UE ; sinon souvent gratuits le 1er dimanche du mois.",
        "Applis anti-gaspillage (Too Good To Go) et seconde main (Vinted, Emmaüs, Le Bon Coin) pour manger et s'équiper à petit prix.",
        "Les marchés bradent souvent fruits et légumes en fin de matinée.",
      ],
      en: [
        "Always keep your student card: discounts on cinema, museums, transport and shows.",
        "National museums are free for EU residents under 26; otherwise often free on the 1st Sunday of the month.",
        "Anti-waste apps (Too Good To Go) and second-hand (Vinted, Emmaüs, Le Bon Coin) to eat and equip yourself cheaply.",
        "Markets often slash fruit and vegetable prices in the late morning.",
      ],
    },
  },
  {
    title: { fr: "Travailler & trouver un stage", en: "Working & finding an internship" },
    icon: "Briefcase",
    tips: {
      fr: [
        "Un stage a besoin d'une convention signée par votre école — il ne compte pas dans vos 964 h autorisées.",
        "CV « à la française » : 1 page, sobre, photo non obligatoire ; la lettre de motivation compte encore.",
        "Le bureau des stages / relations entreprises de votre école est votre meilleur allié — passez-y tôt.",
        "Jobs étudiants accessibles : accueil, restauration, baby-sitting, cours particuliers, événementiel ; regardez aussi le CROUS.",
      ],
      en: [
        "An internship needs a convention signed by your school — it does not count toward your allowed 964 h.",
        "French-style CV: 1 page, plain, photo optional; the cover letter still matters.",
        "Your school's internship / corporate relations office is your best ally — visit it early.",
        "Accessible student jobs: reception, catering, baby-sitting, private tutoring, events; also check the CROUS.",
      ],
    },
  },
  {
    title: { fr: "Ne pas se sentir seul", en: "Not feeling alone" },
    icon: "Users",
    tips: {
      fr: [
        "Rejoignez une association ou un club (sport, musique, langue) dès la rentrée.",
        "Demandez un Buddy dans l'onglet Réseau — quelqu'un qui connaît le terrain change tout les premières semaines.",
        "Le mal du pays est normal et passe ; gardez un rythme (sommeil, repas, sport) et parlez-en.",
        "Beaucoup d'universités ont un soutien psychologique gratuit ; le dispositif « Santé Psy Étudiant » propose aussi des séances prises en charge.",
      ],
      en: [
        "Join an association or a club (sport, music, language) right from the start of the year.",
        "Ask for a Buddy in the Réseau tab — someone who knows the ground changes everything in the first weeks.",
        "Homesickness is normal and passes; keep a routine (sleep, meals, sport) and talk about it.",
        "Many universities offer free psychological support; the « Santé Psy Étudiant » scheme also provides covered sessions.",
      ],
    },
  },
  {
    title: { fr: "S'habiller selon la saison", en: "Dressing for the season" },
    icon: "CloudSun",
    tips: {
      fr: [
        "Automne (sept-nov) : 8-18 °C, temps changeant — veste imperméable + pulls, la superposition est reine.",
        "Hiver (déc-fév) : 0-8 °C, parfois négatif — manteau chaud, écharpe, bonnet, gants, chaussures qui tiennent à la pluie.",
        "Printemps (mars-mai) : 10-20 °C, capricieux — un pull et un coupe-vent suffisent souvent.",
        "Été (juin-août) : 20-30 °C, parfois canicule — vêtements légers, casquette, gourde ; la clim est rare en France.",
      ],
      en: [
        "Autumn (Sep-Nov): 8-18 °C, changeable weather — a waterproof jacket + sweaters, layering is king.",
        "Winter (Dec-Feb): 0-8 °C, sometimes below zero — warm coat, scarf, hat, gloves, rain-proof shoes.",
        "Spring (Mar-May): 10-20 °C, capricious — a sweater and a windbreaker are often enough.",
        "Summer (Jun-Aug): 20-30 °C, sometimes heatwave — light clothes, a cap, a water bottle; air-conditioning is rare in France.",
      ],
    },
  },
  {
    title: { fr: "Vie pratique", en: "Practical life" },
    icon: "Lightbulb",
    tips: {
      fr: [
        "Téléphone : forfaits SIM sans engagement peu chers ; un numéro français aide pour toutes les démarches.",
        "Transports : téléchargez l'appli du réseau de votre ville pour itinéraires et abonnements étudiants.",
        "Urgences : 112 (numéro européen), 15 (SAMU/médical), 17 (police), 18 (pompiers).",
        "Gardez un dossier numérique de vos documents scannés (passeport, VLS-TS, attestations) : on vous les redemande souvent.",
      ],
      en: [
        "Phone: cheap no-commitment SIM plans; a French number helps with all your procedures.",
        "Transport: download your city network's app for routes and student passes.",
        "Emergencies: 112 (European number), 15 (SAMU/medical), 17 (police), 18 (fire brigade).",
        "Keep a digital folder of your scanned documents (passport, VLS-TS, certificates): you'll be asked for them often.",
      ],
    },
  },
];
